import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgCreateFlowsUrl from '@/assets/misc/img_create-flows.svg'
import TeamRolesIllustration from '@/components/SpotIllustration/TeamRolesIllustration'

export interface OCRConfirmBulkReviewDialogProps {
  showing: boolean
  selectedCount: number
  onClose: () => unknown
  onConfirm: () => unknown
}

export function OCRConfirmBulkReviewDialog({
  showing,
  selectedCount,
  onClose,
  onConfirm,
}: OCRConfirmBulkReviewDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={onClose}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgCreateFlowsUrl}
            illustration={byDesign(undefined, TeamRolesIllustration)}
          />
          <ModalSheetContentTitle>
            You are about to set {selectedCount} jobs as ready to submit
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed? Once you change the status, the
            Firm Admin will be able to review and submit these jobs.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" onPress={onClose} />
          <Button
            label="Set As Ready To Submit"
            variant="primary"
            onPress={onConfirm}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
